export const SHIFT_SECTION_SKELETON_LINES = 2
